/**
 * Do not edit directly
 * Generated on Thu, 29 Sep 2022 18:15:25 GMT
 */

export const componentAlertActionButtonFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentAlertActionButtonFontSize = "0.875rem";
export const componentAlertActionButtonHeight = "1.25rem";
export const componentAlertActionButtonTextDecorationDefault = "underline";
export const componentAlertActionButtonTextDecorationFocus = "none";
export const componentAlertActionButtonVariantErrorTextColorDefault = "#9b1419";
export const componentAlertActionButtonVariantErrorTextColorFocus = "#000";
export const componentAlertActionButtonVariantInfoTextColorDefault = "#000";
export const componentAlertActionButtonVariantInfoTextColorFocus = "#000";
export const componentAlertActionButtonVariantSuccessTextColorDefault = "#1d5f02";
export const componentAlertActionButtonVariantSuccessTextColorFocus = "#000";
export const componentAlertActionButtonVariantWarningTextColorDefault = "#662b0d";
export const componentAlertActionButtonVariantWarningTextColorFocus = "#000";
export const componentAlertActionButtonWhiteSpace = "nowrap"; // TODO: figure this out
export const componentAlertContainerBorderRadius = "0.25rem";
export const componentAlertContainerBorderWidthBottom = "0.0625rem";
export const componentAlertContainerBorderWidthLeft = "0.25rem";
export const componentAlertContainerBorderWidthRight = "0.0625rem";
export const componentAlertContainerBorderWidthTop = "0.0625rem";
export const componentAlertContainerFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentAlertContainerFontSize = "0.875rem";
export const componentAlertContainerFontWeight = "400";
export const componentAlertContainerLineHeight = "1.25rem";
export const componentAlertContainerPaddingHorizontal = "1rem";
export const componentAlertContainerPaddingVertical = "0.5rem";
export const componentAlertContainerVariantErrorBackgroundColor = "#fce8e9";
export const componentAlertContainerVariantErrorBorderColorBottom = "#ef8e92";
export const componentAlertContainerVariantErrorBorderColorLeft = "#de1c24";
export const componentAlertContainerVariantErrorBorderColorRight = "#ef8e92";
export const componentAlertContainerVariantErrorBorderColorTop = "#ef8e92";
export const componentAlertContainerVariantErrorTextColor = "#9b1419";
export const componentAlertContainerVariantInfoBackgroundColor = "#f1f1f2";
export const componentAlertContainerVariantInfoBorderColorBottom = "#babbbe";
export const componentAlertContainerVariantInfoBorderColorLeft = "#000";
export const componentAlertContainerVariantInfoBorderColorRight = "#babbbe";
export const componentAlertContainerVariantInfoBorderColorTop = "#babbbe";
export const componentAlertContainerVariantInfoTextColor = "#000";
export const componentAlertContainerVariantSuccessBackgroundColor = "#eaf3e6";
export const componentAlertContainerVariantSuccessBorderColorBottom = "#95c381";
export const componentAlertContainerVariantSuccessBorderColorLeft = "#2a8703";
export const componentAlertContainerVariantSuccessBorderColorRight = "#95c381";
export const componentAlertContainerVariantSuccessBorderColorTop = "#95c381";
export const componentAlertContainerVariantSuccessTextColor = "#1d5f02";
export const componentAlertContainerVariantWarningBackgroundColor = "#fff9e9";
export const componentAlertContainerVariantWarningBorderColorBottom = "#ffe190";
export const componentAlertContainerVariantWarningBorderColorLeft = "#ffc220";
export const componentAlertContainerVariantWarningBorderColorRight = "#ffe190";
export const componentAlertContainerVariantWarningBorderColorTop = "#ffe190";
export const componentAlertContainerVariantWarningTextColor = "#662b0d";
export const componentAlertIconIconSize = "small";
export const componentAlertIconMarginRight = "0.5rem";
export const componentAlertIconVariantErrorIconColor = "#de1c24";
export const componentAlertIconVariantInfoIconColor = "#000";
export const componentAlertIconVariantInfoIconName = "InfoCircle";
export const componentAlertIconVariantSuccessIconColor = "#1d5f02";
export const componentAlertIconVariantSuccessIconName = "CheckCircle";
export const componentAlertIconVariantWarningIconColor = "#662b0d";
export const componentAlertIconVariantWarningIconName = "Warning";
export const componentAlertLabelContainerGapHorizontal = "1rem";
export const componentAlertLabelContainerGapVertical = "0.25rem";
export const componentAlertLabelContainerWrap = "wrap";